module.exports = __webpack_public_path__ + "static/media/5.8_preview.7af81fff.png";